<template>
  <form @change="logChangeData">
    <div class="setting_content">
      <div class="setting_content_main">
        <h2 class="setting_content_title">
          {{ messageLabelsProperties.TAB_HEADER }}
        </h2>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ messageLabelsProperties.ENTRY_SCREEN_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ messageLabelsProperties.STEP_MESSAGE_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="messageLabelsProperties.ENTRY_MESSAGE_PLACEHOLDER"
                v-model="draftMessage.titleEntry"
                @change="validateTitleEntry()"
              />
              <p class="setting_unit_annotation">
                {{ messageNotesProperties.ENTRY_TITLE_NOTE }}
              </p>
              <h6 v-show="lengthErrorTitleEntry" class="error-message">
                {{ messageSettingsProperties.TITLE.ENTRY_TITLE_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ messageLabelsProperties.CONFIRM_SCREEN_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ messageLabelsProperties.STEP_MESSAGE_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="
                  messageLabelsProperties.CONFIRM_MESSAGE_PLACEHOLDER
                "
                v-model="draftMessage.titleConfirm"
                @change="validateTitleConfirm()"
              />
              <p class="setting_unit_annotation">
                {{ messageNotesProperties.CONFIRM_TITLE_NOTE }}
              </p>
              <h6 v-show="lengthErrorTitleConfirm" class="error-message">
                {{ messageSettingsProperties.TITLE.CONFIRM_TITLE_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ messageLabelsProperties.CONFIRM_MESSAGE_BODY_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <textarea
                class="setting_form_textarea"
                :placeholder="
                  messageLabelsProperties.CONFIRM_MESSAGE_PLACEHOLDER
                "
                v-model="draftMessage.messageConfirm"
                @change="validateMessageConfirm()"
              ></textarea>
              <h6 v-show="lengthMessageConfirm" class="error-message">
                {{ messageSettingsProperties.MESSAGE.CONFIRM_BODY_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ messageLabelsProperties.COMPLETE_SCREEN_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ messageLabelsProperties.STEP_MESSAGE_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="
                  messageLabelsProperties.COMPLETE_STEP_MESSAGE_PLACEHOLDER
                "
                v-model="draftMessage.titleCompletion"
                @change="validateTitleCompletion()"
              />
              <p class="setting_unit_annotation">
                {{ messageNotesProperties.COMPLETE_TITLE_NOTE }}
              </p>
              <h6 v-show="lengthErrorTitleCompletion" class="error-message">
                {{ messageSettingsProperties.TITLE.COMPLETE_TITLE_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ messageLabelsProperties.COMPLETE_MESSAGE_SUBJECT_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="
                  messageLabelsProperties.COMPLETE_MESSAGE_PLACEHOLDER
                "
                v-model="draftMessage.messageTitleCompletion"
                @change="validateMessageTitleCompletion()"
              />
              <h6 v-show="lengthMessageTitleCompletion" class="error-message">
                {{
                  messageSettingsProperties.MESSAGE.COMPLETE_TITLE_MAX_LENGTH
                }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ messageLabelsProperties.COMPLETE_MESSAGE_BODY_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <textarea
                class="setting_form_textarea"
                :placeholder="
                  messageLabelsProperties.COMPLETE_MESSAGE_PLACEHOLDER
                "
                v-model="draftMessage.messageBodyCompletion"
                @change="validateMessageBodyCompletion()"
              ></textarea>
              <h6
                v-show="lengthErrorMessageBodyCompletion"
                class="error-message"
              >
                {{ messageSettingsProperties.MESSAGE.COMPLETE_BODY_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
        </div>
        <!-- <div class="setting_unit">
          <p class="setting_unit_title">
            {{ messageLabelsProperties.ERROR_SCREEN_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ messageLabelsProperties.ERROR_MESSAGE_BODY_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <textarea
                class="setting_form_textarea"
                :placeholder="messageLabelsProperties.ERROR_MESSAGE_PLACEHOLDER"
                v-model="draftMessage.messageError"
                @change="validateMessageError()"
              ></textarea>
              <h6 v-show="lengthErrorMessageError" class="error-message">
                {{ messageSettingsProperties.MESSAGE.ERROR_BODY_MAXLENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </form>
</template>

<script>
import messageLabelsProperties from "../../../properties/entry_screen/message_tab/message-labels.json";
import messageSettingsProperties from "../../../properties/entry_screen/message_tab/message-maxlength-settings.json";
import messageNotesProperties from "../../../properties/entry_screen/message_tab/message-notes.json";
import errorProperties from "../../../properties/entry_screen/errors.json";

export default {
  name: "MessageTab",
  props: ["message", "messageError"],
  data() {
    return {
      lengthErrorTitleEntry: false,
      lengthErrorTitleConfirm: false,
      lengthErrorTitleCompletion: false,
      lengthMessageTitleCompletion: false,
      lengthMessageConfirm: false,
      lengthErrorMessageBodyCompletion: false,
      lengthErrorMessageError: false,
      messageSettingsProperties: messageSettingsProperties,
      messageNotesProperties: messageNotesProperties,
      messageLabelsProperties: messageLabelsProperties,
      errorProperties: errorProperties,
      draftMessage: {
        titleEntry: "",
        titleConfirm: "",
        titleCompletion: "",
        messageTitleCompletion: "",
        messageConfirm: "",
        messageBodyCompletion: "",
        messageError: "",
      },
    };
  },
  watch: {
    draftMessage: {
      handler() {
        this.validateTitleEntry();
        this.validateTitleConfirm();
        this.validateTitleCompletion();
        this.validateMessageTitleCompletion();
        this.validateMessageConfirm();
        this.validateMessageBodyCompletion();
        this.validateMessageError();
        this.logChangeData();
      },
      deep: true,
    },
  },
  computed: {
    computedMsgError: {
      get() {
        return this.messageError;
      },
      set(val) {
        this.$emit("updateMsgError", val);
      },
    },
  },
  mounted() {
    this.validateTitleEntry();
    this.validateTitleConfirm();
    this.validateTitleCompletion();
    this.validateMessageTitleCompletion();
    this.validateMessageConfirm();
    this.validateMessageBodyCompletion();
    this.validateMessageError();
    this.draftMessage = this.message;
  },
  methods: {
    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    validateTitleEntry() {
      this.lengthErrorTitleEntry =
        this.draftMessage.titleEntry.length >
        this.messageSettingsProperties.TITLE.ENTRY_TITLE_MAX_LENGTH;
      if (!this.lengthErrorTitleEntry) {
        this.message.titleEntry = this.draftMessage.titleEntry;
      }

      this.checkError();
    },

    validateTitleConfirm() {
      this.lengthErrorTitleConfirm =
        this.draftMessage.titleConfirm.length >
        this.messageSettingsProperties.TITLE.CONFIRM_TITLE_MAX_LENGTH;
      if (!this.lengthErrorTitleConfirm) {
        this.message.titleConfirm = this.draftMessage.titleConfirm;
      }

      this.checkError();
    },

    validateTitleCompletion() {
      this.lengthErrorTitleCompletion =
        this.draftMessage.titleCompletion.length >
        this.messageSettingsProperties.TITLE.COMPLETE_TITLE_MAX_LENGTH;
      if (!this.lengthErrorTitleCompletion) {
        this.message.titleCompletion = this.draftMessage.titleCompletion;
      }

      this.checkError();
    },

    validateMessageTitleCompletion() {
      this.lengthMessageTitleCompletion =
        this.draftMessage.messageTitleCompletion.length >
        this.messageSettingsProperties.MESSAGE.COMPLETE_TITLE_MAX_LENGTH;
      if (!this.lengthMessageTitleCompletion) {
        this.message.messageTitleCompletion =
          this.draftMessage.messageTitleCompletion;
      }

      this.checkError();
    },

    validateMessageConfirm() {
      this.lengthMessageConfirm =
        this.draftMessage.messageConfirm.length >
        this.messageSettingsProperties.MESSAGE.CONFIRM_BODY_MAX_LENGTH;
      if (!this.lengthMessageConfirm) {
        this.message.messageConfirm = this.draftMessage.messageConfirm;
      }

      this.checkError();
    },

    validateMessageBodyCompletion() {
      this.lengthErrorMessageBodyCompletion =
        this.draftMessage.messageBodyCompletion.length >
        this.messageSettingsProperties.MESSAGE.COMPLETE_BODY_MAX_LENGTH;
      if (!this.lengthErrorMessageBodyCompletion) {
        this.message.messageBodyCompletion =
          this.draftMessage.messageBodyCompletion;
      }

      this.checkError();
    },

    validateMessageError() {
      this.lengthErrorMessageError =
        this.draftMessage.messageError.length >
        this.messageSettingsProperties.MESSAGE.ERROR_BODY_MAXLENGTH;
      if (!this.lengthErrorMessageError) {
        this.message.messageError = this.draftMessage.messageError;
      }

      this.checkError();
    },

    checkError() {
      this.computedMsgError =
        this.lengthErrorTitleEntry ||
        this.lengthErrorTitleConfirm ||
        this.lengthErrorTitleCompletion ||
        this.lengthMessageTitleCompletion ||
        this.lengthMessageConfirm ||
        this.lengthErrorMessageBodyCompletion ||
        this.lengthErrorMessageError;
    },
  },
};
</script>
